import {useTranslation} from "react-i18next";
import React from "react";
import useProductName from "../../Hooks/useProductName";
import {productDropdown} from "../../Constants/dropDownLists";
import customerRoutes from "../../Constants/Customer/customerRoutes";
export function CustomerConnectionsTable({customerConnections, customer}) {

    return <table className="table table-stripe table-hover">
        <thead>
            <tr className="bold">
                <CustomerConnectionsHeader/>
            </tr>
        </thead>
        <tbody>
        {customerConnections?.map((connection, index) => {
            return <tr key={index + connection.customerNumber} onClick={() => window.open(customerRoutes.customer(connection.customerNumber), '_blank')}>
            <CustomerConnectionRow key={index} customer={customer} connection={connection}/>

            </tr>
        })}
        </tbody>
    </table>
}
export function CustomerConnectionsHeader() {
    const {t} = useTranslation();

    return (<>
            <th>{t('customerconnections.main')}
                <small>{t('customerconnections.namecustnoorgno')}</small>
            </th>
            <th>{t('customerconnections.sub')}
                <small>{t('customerconnections.namecustnoorgno')}</small>
            </th>
            <th>{t('customerconnections.product')}</th>
        </>
    )
}

export function CustomerConnectionRow({ connection, customer}) {
    const {translatedProductName} = useProductName();

    const isMain = connection.type === 0;
    const mainCustomer = isMain ? getCustomerInfo(connection) : getCustomerInfo(customer);
    const subCustomer = isMain ? getCustomerInfo(customer) : getCustomerInfo(connection);
    return (<>
            <td>{mainCustomer.name} / {mainCustomer.customerNumber} / {mainCustomer.organizationNumber}</td>
            <td>{subCustomer.name} / {subCustomer.customerNumber} / {subCustomer.organizationNumber}</td>
            <td>{translatedProductName(productDropdown.find(p => p.id === connection.product)?.tName)}</td>
        </>
    )
}

function getCustomerInfo(source) {
    return {
        name: source.name,
        customerNumber: source.customerNumber,
        organizationNumber: source.organizationNumber
    };
}
